<template>
  <div class="quiz">
    
    <header class="wrap">
      <h1>Preparing Solutions</h1>
      <h2>Score: {{currentScore}} / {{questionSet.length}}</h2>
      <span>Question {{currentQCount+1}} / {{questionSet.length}}</span>
    </header>
  
    <transition name="fade" mode="out-in">  
      <div v-if="!finished && !demoStep" key="one">
        <div class="currentQ wrap">
          
          <div class="left">
            <flask :src="baseUrl + 'img/' + currentQ.solutionChemicalImage + '.svg'" :key="currentQ.solutionChemicalImage"></flask>
          </div>

          <div class="right">

            <h2 v-html="currentQ.question"></h2>

            <div class="choices" :class="{ wrong: firstWrong, correct: firstCorrect }">

              <div class="choice choiceA" :class="{ shown: firstWrong && currentQ.answer == 'A' }">
                <input type="radio" name="answerChoice" id="answerA" value="A" v-model="answerChoice" :disabled="firstWrong || firstCorrect">
                <label for="answerA"><span v-html=" currentQ.choices.A "></span></label>
              </div>

              <div class="choice choiceB" :class="{ shown: firstWrong && currentQ.answer == 'B' }">
                <input type="radio" name="answerChoice" id="answerB" value="B" v-model="answerChoice" :disabled="firstWrong || firstCorrect">
                <label for="answerB"><span v-html=" currentQ.choices.B "></span></label>
              </div>

              <div class="choice choiceC" :class="{ shown: firstWrong && currentQ.answer == 'C' }">
                <input type="radio" name="answerChoice" id="answerC" value="C" v-model="answerChoice" :disabled="firstWrong || firstCorrect">
                <label for="answerC"><span v-html=" currentQ.choices.C "></span></label>
              </div>

              <div class="choice choiceD" :class="{ shown: firstWrong && currentQ.answer == 'D' }">
                <input type="radio" name="answerChoice" id="answerD" value="D" v-model="answerChoice" :disabled="firstWrong || firstCorrect">
                <label for="answerD"><span v-html=" currentQ.choices.D "></span></label>
              </div>

            </div>

            <div class="submit" v-if="!firstWrong && !firstCorrect">
              <button class="btn" v-on:click="submitFirst">Submit</button>
            </div>

            <div class="continue-wrong" v-if="firstWrong">
              <div class="formula" :style="'background-image:url(' + baseUrl + 'img/' + currentQ.formulaImage + '.svg)'" :key="currentQ.formulaImage">
                <button class="btn cont" v-on:click="continueFirst">Continue</button>
              </div>
              <p class="error">Sorry, that is incorrect.<br> Correct answer shown. Continue to learn more about this solution.</p>
            </div>

            <div class="continue-correct" v-if="firstCorrect">
              <button class="btn cont" v-on:click="continueFirst">Continue</button>
              <p class="success">Correct Answer! Continue to learn more about this solution.</p>
            </div>        
          </div>
        </div>
      </div>

      <div v-if="!finished" key="two">
        <div class="demo" v-show="demoStep == 1">
          <h2>Volume</h2>
          <h3>Let's prepare a <strong>{{currentQ.solutionVolume}}</strong> of solution using a <strong>{{currentQ.solutionVolume}}</strong> volumetric flask.</h3>
          <div class="flask-choices wrap">
            <span :class="currentQ.solutionVolume == '100 ml' ? 'active' : ''">
              <img :src="baseUrl + 'img/100ml.png'" alt="100 ml flask"></span>
            <span :class="currentQ.solutionVolume == '250 ml' ? 'active' : ''">
              <img :src="baseUrl + 'img/250ml.png'" alt="250 ml flask"></span>
            <span :class="currentQ.solutionVolume == '500 ml' ? 'active' : ''">
              <img :src="baseUrl + 'img/500ml.png'" alt="500 ml flask"></span>
            <span :class="currentQ.solutionVolume == '1000 ml' ? 'active' : ''">
              <img :src="baseUrl + 'img/1000ml.png'" alt="1000 ml flask"></span>
          </div>
          <div class="submit">
            <button class="btn cont" v-on:click="nextSecond">Next Step</button>
          </div>
          <br>
        </div>

        <div class="currentQ wrap" v-show="demoStep == 2 || demoStep == 3">
          <div class="left demo">
            <img :src="baseUrl + 'img/flask-low.png'" alt="flask">
          </div>
          <div class="right demo">
            <h2>Mass</h2>
            <h3>Measure <strong v-html="currentQ.solutionMeasure"></strong> of <strong v-html="currentQ.solutionChemical"></strong></h3>
            
            <div class="submit" v-show="demoStep == 2">
              <button class="btn cont alt" v-on:click="nextSecond">Continue: Measure</button>
            </div>
            <div class="submit" v-show="demoStep == 3">
              <button class="btn cont" v-on:click="nextSecond">Next Step: Dissolve</button>
            </div>

            <div class="scale">
              <img :src="baseUrl + 'img/paper.png'" alt="paper" class="paper-img">
              <transition name="drop">
                <img :src="baseUrl + 'img/powder.png'" alt="powder" class="powder-img" v-show="demoStep == 3">
              </transition>
              <img :src="baseUrl + 'img/scale1.png'" alt="scale" class="scale-img">
              <span class="scaleweight" v-show="demoStep == 2">0.00</span>
              <span class="scaleweight" v-show="demoStep == 3" v-html="currentQ.solutionMeasure.replace(' g','')"></span>
              <span class="scaleweight g">g</span>
            </div>
          </div>
        </div>

        <div v-show="demoStep >= 4">
          <div class="currentQ wrap">
            <div class="left" :class="demoStep <= 10 ? 'demo' : ''">
              <transition name="demostep" mode="out-in">
                
                <div v-if="demoStep >= 4 && demoStep <= 6" key="46" class="flask-stuff-holder">
                  <img :src="baseUrl + 'img/flask-empty.png'" alt="flask" class="flask-empty">
                  <transition name="drop">
                    <img :src="baseUrl + 'img/powder.png'" alt="powder" class="powder-img-flask" v-if="demoStep == 5 || demoStep == 6">
                  </transition>
                  <div class="fluid" :style="fluidStyle[demoStep]"></div>
                  <img :src="baseUrl + 'img/flask-out.png'" alt="flask" class="flask-out">
                  <img v-if="demoStep == 10" :src="baseUrl + 'img/flask-out-flip.png'" alt="flask" class="flask-out">
                  <div class="top-cover"></div>
                </div>

                <div class="mixing-flask-container" v-if="demoStep == 7" key="7">
                  <img :class="demoStep == 7 ? 'mix' : 'nomix'" :src="baseUrl + 'img/flask-bulb-mix.png'" alt="flask">
                </div>

                <div v-if="demoStep >= 8 && demoStep <= 10" key="89">
                  <flask :src="baseUrl + 'img/' + currentQ.solutionChemicalImage + '.svg'" :key="currentQ.solutionChemicalImage" :fluidStyle="fluidStyle[demoStep]" :top="demoStep < 10 ? true : false" :flipped="demoStep == 10"></flask>
                </div>

              </transition>
            </div>
            <div class="right demo">
              <h2>Dissolve</h2>
              <ol class="dissolvesteps">
                <li :class="demoClasses[demoStep + '_1']">Add the solute to the volumetric flask</li>
                <li :class="demoClasses[demoStep + '_2']">Add water to fill bulb</li>
                <li :class="demoClasses[demoStep + '_3']">Mix</li>
                <li :class="demoClasses[demoStep + '_4']">Slowly add water to fill line</li>
                <li :class="demoClasses[demoStep + '_5']">Invert flask</li>
              </ol>
              <div class="submit" v-show="demoStep < 10">
                <button class="btn cont alt" v-on:click="nextSecond" v-show="demoStep == 4">Continue: Add Solute</button>
                <button class="btn cont alt" v-on:click="nextSecond" v-show="demoStep == 5">Continue: Add Water</button>
                <button class="btn cont alt" v-on:click="nextSecond" v-show="demoStep == 6">Continue: Mix</button>
                <button class="btn cont alt" v-on:click="nextSecond" v-show="demoStep == 7">Continue</button>
                <button class="btn cont alt" v-on:click="nextSecond" v-show="demoStep == 8">Continue: Add Water</button>
                <button class="btn cont alt" v-on:click="nextSecond" v-show="demoStep == 9">Continue</button>
              </div>        
              <div class="submit" v-show="demoStep == 10">
                <button class="btn cont" v-on:click="continueSecond">Next Question</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="finished" v-if="finished" key="three">
        <h1>You are finished! You scored {{currentScore}} / {{questionSet.length}}.</h1>
        <button class="btn" v-on:click="resetEverything">Start Over</button>
      </div>
    </transition>

  </div>
</template>

<script>
import Flask from './Flask.vue'
export default {
  name: 'Quiz',
  components: { Flask },
  props: [ 'questions' ],
  data: function () {
    return {
      baseUrl: process.env.BASE_URL,
      questionSet: [],
      currentQ: {},
      currentQCount: 0,
      currentScore: 0,
      answerChoice: '',
      firstWrong: false,
      firstCorrect: false,
      demoStep: false,
      finished: false,
      fluidStyle: {
        '3': 'height: 67.5%;background-position:50% 0%;background-size:300% auto;',
        '4': 'height: 6%;background-position:50% 0%;background-size:300% auto',
        '5': 'height: 6%;background-position:10% 0%;background-size:200% auto;',
        '6': 'height: 29%;background-position:9.5% 0%;background-size:400% auto;',
        '7': 'height: 29%;background-position:81% 0%;background-size:400% auto;',
        '8': 'height: 29%;background-position:50% 0%;background-size:300% auto;',
        '9': 'height: 64%;background-position:50% 0%;background-size:300% auto;transition: all 5s cubic-bezier(0,0,0,1)',
        '10': 'height: 64%;background-position:50% 0%;background-size:300% auto;'
      },
      demoClasses: {
        '4_1': 'on', '4_2': '', '4_3': '', '4_4': '', '4_5': '',
        '5_1': 'strike', '5_2': 'on', '5_3': '', '5_4': '', '5_5': '',
        '6_1': 'strike', '6_2': 'strike', '6_3': 'on', '6_4': '', '6_5': '',
        '7_1': 'strike', '7_2': 'strike', '7_3': 'on', '7_4': '', '7_5': '',
        '8_1': 'strike', '8_2': 'strike', '8_3': 'strike', '8_4': 'on','8_5': '',
        '9_1': 'strike', '9_2': 'strike', '9_3': 'strike', '9_4': 'strike', '9_5': 'on',
        '10_1': 'strike', '10_2': 'strike', '10_3': 'strike', '10_4': 'strike', '10_5': 'strike',
      }
    }
  },
  methods: {
    resetEverything: function() {
      this.setQuestions();
      this.$emit('restartQuiz');
    },
    setQuestions: function() {
      var a = this.questions;

      //all questions in order
      //this.questionSet = a;

      //shuffle the questions
      // for (let i = a.length - 1; i > 0; i--) {
      //   const j = Math.floor(Math.random() * (i + 1));
      //   [a[i], a[j]] = [a[j], a[i]];
      // }
      // this.questionSet = a;

      //5 random questions
      this.questionSet = a.sort(() => .5 - Math.random()).slice(0,5);

      this.currentQCount = 0;
      this.currentQ = this.questionSet[0];
      this.resetStuff();
      this.finished = false;
      this.currentScore = 0;
    },
    resetStuff: function() {
      this.answerChoice = '';
      this.firstWrong = false;
      this.firstCorrect = false;
      this.demoStep = false;
    },
    submitFirst: function() {
      if(this.answerChoice == '') { return; }
      else if(this.answerChoice != this.currentQ.answer) {
        this.firstWrong = true;
      } else {
        this.firstCorrect = true;
        this.currentScore++;
      }
    },
    continueFirst: function() {
      this.demoStep = 1;
    },
    nextSecond: function() {
      this.demoStep++;
    },
    continueSecond: function() {
      //next question or end?
      if(this.currentQCount == this.questionSet.length - 1) {
        this.finished = true;
      } else {
        this.currentQCount++;
        this.currentQ = this.questionSet[this.currentQCount];
        this.resetStuff();
      }
    }
  },
  created: function () {
    this.setQuestions();
  }
}
</script>


<style lang="scss">
@import "../assets/styles.scss";

@font-face {
  font-family: 'IBMPlexMono';
  src: url('~@/assets/IBMPlexMono-Regular.ttf') format('truetype');
}

header {
  display: flex;
  justify-content: space-between;
  h1, h2, span { 
    display: inline-block; 
    margin: 1rem 0;
    font-size: 1rem;
    text-transform: uppercase;
    font-weight: bold;
  }
}
.currentQ {
  display: flex;
  justify-content: space-around;
  text-align: center;
}
.left { width: 35%; }
.right { 
  margin-top: 10%;
  width: 65%; 
}
.right:not(.demo) h2 { font-size: 1em; font-weight: normal; line-height: 1.5; }
.left.demo { width: 35%; }
.left img { max-width: 85%; transition: all 0.2s ease; }
.left.demo img {
  width: 85%;
  margin-top: 10%;
}
.right.demo { width: 65%; }
.choices { 
  display: flex;
  margin: 1rem auto 0;
  justify-content: space-around;
  flex-wrap: wrap;
  height: 10rem;

  .choice {
    width: 50%;
    padding: 0 1rem;
  }

  input { display: none; }
  input + label {
    display: inline-block;
    cursor: pointer;
    width: 100%;
    span {
      border: solid 1px #000;
      color: $dk_grey;
      padding: 1rem 0;
      display: block;
      font-size: 1.1rem;
      font-weight: bold;
      white-space: nowrap;
      .long & { font-size: 1rem; }
    }
  }
  input:checked + label {
    span { 
      background: #ccc;
      color: #1b1b1b;
      border-color: $blue;
    }
    &:hover { cursor: default; }
  }
  &.correct input:checked + label span,
  &.wrong .shown input + label span { 
    box-shadow: 0 0 0 2px $blue; 
    border-color: $blue;
    position: relative;
    display: block;
    width: 100%;
    &:before {
      display: block;
      position: absolute;
      left: -2rem;
      top: 0;
      font-size: 3rem;
      content: "\2713";
      color: $blue;
    }
  }
  &.wrong input:checked + label span { border: solid 1px $red; }  
}
.wrong, .correct {
  label { pointer-events: none; }
}
.demo {
  h3 { font-weight: normal; }
}
.currentQ, .demo {
  h2, h3 {
    strong {
      white-space:nowrap;
    }
  }
}
.finished {
  padding-top: 2rem;
}

.flask-choices {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -2rem !important;
  span {
    display: block;
    padding: 20px;
    opacity: 0.4;
    &.active { opacity: 1; }
    img { 
      max-width: 100%; 
    }
  }
}

.scale {
  position: relative;
  padding: 2rem 0;
  text-align: center;


  .scale-img { 
    margin-left: 2rem;
    margin-top: 5rem;
    max-width: calc(100% - 2rem);
    position: relative;
    z-index: 1;
  }

  span { 
    position: absolute; 
    bottom: 45%;
    color: #000;
    left: 0;
    width: 100%;
    text-align: center;
    height: 2rem;
    font: normal 2rem 'IBMPlexMono';
    z-index: 4;
    &.g {
      font-size: 1rem;
      text-indent: 8rem;
    }
  }

  .paper-img, .powder-img { 
    position: absolute; 
    top: 25%;
    left: 35%;
    width: 30%;
    height: auto;
    z-index: 2;
  }
  .powder-img {
    top: 17.5%;
    left: 40%;
    width: 20%;
    position: absolute; 
    z-index: 3;
  }

}

.dissolvesteps {
  text-align: left;
  max-width: 28rem;
  margin: 2rem auto;
  li { 
    padding: 0.5rem; 
    opacity: 0.4;
    &.on { transition: all 0.4s ease; opacity: 1; }
    &.strike { opacity: 0.5; text-decoration: line-through; }
  }
}

.flask-container { 
  position: relative; 
}
.mixing-flask-container {
  padding: 5px;
}
.left.demo img.powder-img-flask { 
  position: absolute; 
  bottom: 3%;
  left: 32.5%;
  width: 35%;
  opacity: 0.5;
  z-index: 3;
}

.fluid {
  background: transparent no-repeat 50% 0% / 300% auto;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='587.78' height='927.38' viewBox='0 0 587.78 927.38'%3E%3Cdefs%3E%3Cstyle%3E .cls-1 %7B opacity: 0.5; %7D .cls-2 %7B fill: url(%23linear-gradient); %7D %3C/style%3E%3ClinearGradient id='linear-gradient' x1='293.89' y1='927.38' x2='293.89' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0.04' stop-color='%237ee6e6'/%3E%3Cstop offset='0.11' stop-color='%2367e3f1'/%3E%3Cstop offset='0.19' stop-color='%2356e1f9'/%3E%3Cstop offset='0.28' stop-color='%234bdffd'/%3E%3Cstop offset='0.38' stop-color='%2348dfff'/%3E%3Cstop offset='0.65' stop-color='%2348dfff'/%3E%3Cstop offset='0.79' stop-color='%2346defe'/%3E%3Cstop offset='0.86' stop-color='%233edbfc'/%3E%3Cstop offset='0.91' stop-color='%2332d6f8'/%3E%3Cstop offset='0.95' stop-color='%231fcff2'/%3E%3Cstop offset='0.99' stop-color='%2308c5eb'/%3E%3Cstop offset='1' stop-color='%2300c2e8'/%3E%3C/linearGradient%3E%3C/defs%3E%3Ctitle%3EAsset 6%3C/title%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='layer_1-2' data-name='layer_1'%3E%3Cg class='cls-1'%3E%3Cpath class='cls-2' d='M587.24,923.88c-9.9,5.23-11.66-1.88-22.85-1.88s-11.2,2-22.39,2-11.19-2-22.39-2-11.19,2-22.38,2-11.2-2-22.39-2-11.2,2-22.39,2-11.2-2-22.39-2-11.19,2-22.39,2-11.19-2-22.39-2-11.19,2-22.39,2-11.19-2-22.39-2-11.19,2-22.39,2-11.19-2-22.39-2-11.19,2-22.39,2-11.19-2-22.39-2-11.19,2-22.39,2-11.19-2-22.39-2-11.19,2-22.39,2-11.19-2-22.39-2-11.19,2-22.39,2-11.19-2-22.39-2-11.2,2-22.39,2-11.2-2-22.4-2-11.19,2-22.39,2-11.2-2-22.4-2S9.76,933,3.78,923.53c-9.47-15,1.84-18.26,1.84-36s-2-17.73-2-35.46,2-17.73,2-35.45-2-17.73-2-35.46,2-17.73,2-35.46-2-17.73-2-35.46,2-17.73,2-35.46-2-17.73-2-35.45,2-17.73,2-35.46-2-17.73-2-35.46,2-17.73,2-35.47-2-17.73-2-35.46,2-17.73,2-35.46-2-17.73-2-35.46,2-17.73,2-35.46-2-17.73-2-35.46,2-17.73,2-35.47-2-17.73-2-35.46,2-17.73,2-35.46-2-17.73-2-35.46,2-17.73,2-35.46-2-17.74-2-35.47,2-17.73,2-35.46-2-17.74-2-35.47,2-17.73,2-35.47S0,18.15,3.64.79C11.11.79,19.55,2,27,2S41.94,0,49.4,0,64.33,2,71.79,2s14.93-2,22.4-2,14.92,2,22.39,2S131.5,0,139,0s14.92,2,22.39,2,14.92-2,22.39-2,14.92,2,22.39,2,14.92-2,22.39-2,14.93,2,22.39,2,14.93-2,22.39-2,14.93,2,22.39,2,14.93-2,22.39-2S333,2,340.48,2s14.93-2,22.39-2,14.93,2,22.39,2,14.93-2,22.39-2S422.58,2,430,2,445,0,452.43,0s14.93,2,22.39,2,14.93-2,22.39-2,14.93,2,22.39,2S534.53,0,542,0s14.92,2,22.39,2S580.16.47,587.62.47c0,11.82-1.84,24.17-1.84,36s2,23.64,2,35.46-2,23.64-2,35.46,2,23.65,2,35.47-2,23.64-2,35.46,2,23.64,2,35.46-2,23.64-2,35.46,2,23.64,2,35.46-2,23.64-2,35.46,2,23.64,2,35.47-2,23.64-2,35.46,2,23.64,2,35.46-2,23.64-2,35.46,2,23.64,2,35.46-2,23.64-2,35.46,2,23.64,2,35.46-2,23.65-2,35.47,2,23.64,2,35.46-2,23.64-2,35.46,2,23.64,2,35.46-2,23.64-2,35.46,2,23.64,2,35.46-2,23.64-2,35.47,2,23.64,2,35.46-2,23.64-2,35.46S587.24,912.06,587.24,923.88Z'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A");
  opacity: 0.75;
  position:absolute;
  bottom:2%;
  left:10%;
  display:block;
  width:80%;
  z-index:2;
  transition: all 2s ease-in-out;
  //border-top-left-radius: 100%;
  //border-top-right-radius: 100%;
}
.flask-empty { 
  position:relative;
  z-index:1;
}
.flask-out { 
  position:absolute;
  top:0;
  left:7.5%;
  z-index:3;
}
.flask-stuff-holder {
  position:relative;
}
.top-cover {
  background: #fff;
  z-index: 5;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 13.7%;
}
.mix {
  animation: mix 1.5s both infinite;
  transform-origin: bottom center;
}
.nomix { transition: none; animation: none; transform: translate3d(5%, 2.5%, 0) rotate3d(0, 0, 1, 5deg); }
@keyframes mix {
  from { transform: translate3d(5%, 2.5%, 0) rotate3d(0, 0, 1, 5deg); }
  10% { transform: translate3d(-5%, -2.5%, 0) rotate3d(0, 0, 1, 9deg); }
  20% { transform: translate3d(5%, 2.5%, 0) rotate3d(0, 0, 1, 11deg); }
  30% { transform: translate3d(-5%, -2.5%, 0) rotate3d(0, 0, 1, 9deg); }
  40% { transform: translate3d(5%, 2.5%, 0) rotate3d(0, 0, 1, 11deg); }  
  50% { transform: translate3d(0%, -2.5%, 0) rotate3d(0, 0, 1, 5deg); }
  60% { transform: translate3d(5%, 2.5%, 0) rotate3d(0, 0, 1, 2deg); }
  70% { transform: translate3d(-5%, -2.5%, 0) rotate3d(0, 0, 1, 4deg); }
  80% { transform: translate3d(5%, 2.5%, 0) rotate3d(0, 0, 1, 5deg); }
  90% { transform: translate3d(-5%, -2.5%, 0) rotate3d(0, 0, 1, 4deg); }  
  to { transform: translate3d(5%, 2.5%, 0) rotate3d(0, 0, 1, 5deg); }
}
.formula {
  background-repeat: no-repeat;
  background-position: 50% 55%;
  background-size: 100% auto;
  height: 15rem;
  border: solid 1px $blue;
  padding-top: 13.5rem;
  margin-bottom: 2rem;
}
.modal-wrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
}
.modal {
  position: absolute;
  top: 5%;
  left: 10%;
  width: 80%;
  height: 90%;
  background: #fff;
  box-shadow: 0 2px 8px -4px rgba(0,0,0,0.05);
  padding-top: 1rem;
  text-align: center;
  overflow-y: auto;
  img {
    margin-top: 1rem;
    max-width: 96%;
  }
  .close-modal {
    border-radius: 50%;
    color: #fff;
    background: $blue;
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: 2rem;
    width: 2rem;
    height: 2rem;
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    cursor: pointer;
  }
}
p.success {
  margin: 1rem 0;
  color: $blue;
}
p.error {
  margin: 1rem 0;
  color: $red;
}
.btn.cont {
  padding: 0.6rem 4rem;
  position: relative;
  &:after {
    display: block;
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    content: "\276F";
    color: #fff;
  }

  &.alt {
    padding: 0.6rem;
    &:after {
      display: none;
    }
  }
}

.demostep-enter-active, .demostep-leave-active {
  transition: opacity .25s;
}
.demostep-enter, .demostep-leave-to {
  opacity: 0;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.drop-enter-active, .drop-leave-active {
  transition: transform .5s;
}
.drop-enter, .drop-leave-to {
  transform: translateY(-1000%);
}


</style>
